module.exports = __webpack_public_path__ + "components/country-flag/static/xx-4e4091978e9db6e10489579dfb5d5471.svg";